import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SettingWorkOrderEmail from 'Setting/Components/setting-work-order-email';
import SettingProjectEmail from 'Setting/Components/setting-project-email';
import SettingOverdue from 'Setting/Components/setting-overdue';
import { SwitchButton } from 'components/switch-button';
import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';
import * as ProjectActionType from '../constants';

class ProjectAddEditSettings extends Component {

  static propTypes = {
    history: PropTypes.object,
    AssigneeNotice: PropTypes.any,
    ProjectSetting: PropTypes.any,
    match: PropTypes.object,
    dispatch: PropTypes.func,
    projectId: PropTypes.string,
    NotifyRFS: PropTypes.any
  }

  constructor(props) {
    super(props);

    this.state = {
      projectName: '',
      isUseDefaultSettingEmailNotify: null,
      isUseDefaultSettingOverdue: null,
      isEnabledSettingProject: null,
      isEnabledSettingWorkOrder: null,
      overdue: null
    };

    this.projectId = this.props.match.params.projectId ? this.props.match.params.projectId : this.props.projectId;

    this.isNew = this.props.match.params.isNew === 'true';

    var me = this;

    PubSub.subscribe(PubSubActionType.PUBLISH_PROJECT_INFORMATION, (msg, data) => {
      me.setState({ projectName: data.project.name });
    });

  }

  componentDidMount() {
    this.props.dispatch({
      type: ProjectActionType.GET_PROJECT_SETTING_ASYNC,
      params: {
        projectId: this.projectId
      }
    });

    this.props.dispatch({
      type: ProjectActionType.GET_PROJECT_SETTING_NOTICE_RFS_ASYNC,
      params: {
        projectId: this.projectId
      }
    });

    this.props.dispatch({
      type: ProjectActionType.GET_SETTING_ASSIGNEE_NOTICE_BY_PROJECT_ASYNC,
      params: {
        id: this.projectId
      }
    });
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.ProjectSetting) {
      this.setState({
        isUseDefaultSettingEmailNotify: nextProps.ProjectSetting.useDefaultEmailNotification,
        isUseDefaultSettingOverdue: nextProps.ProjectSetting.useDefaultOverDue,
        isEnabledSettingProject: nextProps.ProjectSetting.sendProjectNotification,
        isEnabledSettingWorkOrder: nextProps.ProjectSetting.sendWONotification,
        overdue: nextProps.ProjectSetting.workOrderDueIn
      });
    }
  }

  componentWillUnmount() {

    this.props.dispatch({
      type: ProjectActionType.CREATE_ASSIGNEE_NOTICE_RESET,
      params: null
    });

    // this.props.dispatch({
    //   type: ProjectActionType.RESET_PROJECT,
    //   params: null
    // });
  }

  onChangeSwitch = type => {
    this.setState({
      [type]: !this.state[type]
    }, () => {
      this.onSaveProjectSetting();
    });
  }

  onSave = (type, data) => {
    this.setState({
      [type]: data
    }, () => {
      this.onSaveProjectSetting();
    });
  }

  onSaveProjectSetting = () => {
    const param = {
      workOrderDueIn: this.state.overdue,
      sendProjectNotification: this.state.isEnabledSettingProject,
      sendWONotification: this.state.isEnabledSettingWorkOrder,
      useDefaultOverDue: this.state.isUseDefaultSettingOverdue,
      useDefaultEmailNotification: this.state.isUseDefaultSettingEmailNotify
    };
    this.props.dispatch({
      type: ProjectActionType.UPDATE_PROJECT_SETTING_ASYNC,
      params: {
        projectId: this.projectId,
        param
      }
    });
  }

  onSaveWorkOrderNotice = (params) => {
    const data = {
      closeRequestSinceLastNoticeSent: params.closeNumOfDay,
      notices: [
        {
          content: params.first,
          order: 1,
          sendAfter: 0
        },
        {
          content: params.second,
          order: 2,
          sendAfter: params.secondNumOfDay
        },
        {
          content: params.third,
          order: 3,
          sendAfter: params.thirdNumOfDay
        }
      ]
    };
    this.props.dispatch({
      type: ProjectActionType.UPDATE_PROJECT_SETTING_NOTICE_RFS_ASYNC,
      params: {
        projectId: this.projectId,
        param: data
      }
    });
  }

  onSaveAssigneeNotice = (data) => {
    this.props.dispatch({
      type: ProjectActionType.SETTING_UPDATE_ASSIGNEE_NOTICE_ASYNC,
      params: {
        id: this.projectId,
        param: data
      }
    });
  }

  render() {
    return <div className='box-form-body'>
      <div className='builder-setting-project-operation'>
        <p className='setting-block-title'>Email notifications</p>
        <p className='setting-default-title'>Use default settings
          <span>
            <SwitchButton
              name='switch'
              style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: 20}}
              checked={this.state.isUseDefaultSettingEmailNotify}
              onCheck={() => this.onChangeSwitch('isUseDefaultSettingEmailNotify')} />
          </span>
        </p>
        <SettingProjectEmail
          isDisabledSwitchButton={true}
          isNotAllowedEdit={this.state.isUseDefaultSettingEmailNotify}
          assigneeNotice={this.props.AssigneeNotice}
          projectOperation={this.props.ProjectSetting}
          onSaveProjectOperation={(data) => this.onSave('isEnabledSettingProject', data)}
          onSaveAssigneeNotice={this.onSaveAssigneeNotice}
        />

        <SettingWorkOrderEmail
          isNotAllowedEdit={this.state.isUseDefaultSettingEmailNotify}
          noticeRequest={this.props.NotifyRFS}
          projectOperation={this.props.ProjectSetting}
          onSaveProjectOperation={(data) => this.onSave('isEnabledSettingWorkOrder', data)}
          onSaveNotice={this.onSaveWorkOrderNotice}
        />

        <p className='setting-block-title' style={{marginTop: 40}}>Overdue value</p>
        <p className='setting-default-title'>Use default settings
          <span>
            <SwitchButton
              name='switch'
              style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: 20}}
              checked={this.state.isUseDefaultSettingOverdue}
              onCheck={() => this.onChangeSwitch('isUseDefaultSettingOverdue')} />
          </span>
        </p>
        <SettingOverdue
          isProjectLevel={true}
          isNotAllowedEdit={this.state.isUseDefaultSettingOverdue}
          projectOperation={this.props.ProjectSetting}
          onSaveProjectOperation={(data) => this.onSave('overdue', data)}
          isHiddenCountDay
        />
      </div>

    </div>;
  }
}

const mapStateToProps = (state) => {
  return {
    ProjectSetting: state.ProjectStore.ProjectSetting,
    NotifyRFS: state.ProjectStore.NotifyRFS,
    AssigneeNotice: state.ProjectStore.AssigneeNotice
  };
};

export default connect(mapStateToProps)(ProjectAddEditSettings);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-settings.js